module.exports = __webpack_public_path__ + "img/seamless-embed.bb3d9145.svg";